import store from '../redux/store';
import { mapPendingOrderAdressToAddress } from '../utils/addressUtils';
import { logMediumError } from '../utils/logger';
import { API_DELIVERABLE_SHOPS } from './api';
import { sendGetRequest } from './backend';

export const getDeliverableShopsFromAddress = async (address: any) => {
  const { companyId } = store.getState().configurationReducer;
  try {
    const response = await sendGetRequest(
      API_DELIVERABLE_SHOPS(companyId),
      mapPendingOrderAdressToAddress(address),
      false
    );

    return response.data;
  } catch (error) {
    logMediumError(
      `Failed to get deliverable shop from company (${companyId})  ${error}`
    );

    throw error;
  }
};
